module.exports = __webpack_public_path__ + "img/plan01_text0202_m.1d259035.png";